const Plans = {

    // PAGE HEADER
    "active_plan": "Active Plan",
    "future_plan": "Future Plan",
    "plan_history": "Plan History",
    "associated_vas": "Associated Vas",
    "search": "Search",

    // TOAST
    "no_vas": "No Associated VAS with this Plan",

    // TABLE HEADER
    "table_plan_name": "PLAN NAME",
    "table_plan_type": "PLAN TYPE",
    "table_validity_type": "VALIDITY TYPE",
    "table_service_type": "SERVICE TYPE",
    "table_addon": "ADDON",
    "table_validity": "VALIDITY",
    "table_total_quota": "TOTAL QUOTA",
    "table_used_quota": "USED QUOTA",
    "table_start_date": "START DATE",
    "table_end_date": "END DATE",
    "table_activation_date": "ACTIVATION DATE",
    "table_expiry_date": "EXPIRY DATE",
    "table_vas": "ASSOCIATED VAS DETAILS",

    // VAS POPUP TABLE
    "table_id": "ID",
    "table_vas_name": "VAS NAME",
    "table_vas_type": "VAS TYPE",
    "table_provider_name": "PROVIDER NAME",
    "table_validity_days": "VALIDITY (DAYS)",
    "days": "Days",

}

export default Plans;
